interface QuizViewLockedProps {
  roomId: string;
  inputPassword: string;
  setInputPassword: (pw: string) => void;
  onSubmit: () => void;
}

export const QuizViewLocked = (
  { roomId: _roomId, inputPassword, setInputPassword, onSubmit }:
    QuizViewLockedProps,
) => {
  return (
    <div
      key="view-locked"
      class="flex flex-col items-center justify-center h-screen bg-base-200 p-4 space-y-6"
    >
      <div class="text-center space-y-2">
        <h2 class="text-4xl font-black text-error tracking-tighter uppercase">
          Locked
        </h2>
        <p class="opacity-60 font-bold italic">
          This room requires a password.
        </p>
      </div>
      <div class="card w-full max-w-sm bg-base-100 shadow-2xl">
        <div class="card-body space-y-4">
          <div class="form-control">
            <label class="label">
              <span class="label-text font-bold">Password</span>
            </label>
            <input
              type="password"
              class="input input-bordered w-full font-bold"
              placeholder="Enter password..."
              autoFocus
              value={inputPassword}
              onInput={(e) =>
                setInputPassword((e.target as HTMLInputElement).value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") onSubmit();
              }}
            />
          </div>
          <button
            type="button"
            class="btn btn-primary w-full font-black"
            onClick={onSubmit}
          >
            Join Room
          </button>
          <a href="/quiz" class="btn btn-ghost btn-xs opacity-50 font-black">
            Cancel
          </a>
        </div>
      </div>
    </div>
  );
};
